import { NgClass, NgIf } from '@angular/common';
import { Component, HostListener, inject, Renderer2, ViewChild, ElementRef } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';
import { Router } from '@angular/router';
import { Constants } from '../../shared/utils/constants';
import { AuthService } from '../../services/auth/auth.service';
import { RoleService } from '../../services/role/role.service';
import { ToggleService } from '../../services/toggle-service/toggle-service.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NgClass, NgIf],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  public isLoggedIn: boolean = false;
  isScrolleds = false;
  active: boolean = true
  loaderService = inject(LoaderService);
  authService = inject(AuthService)
  route = inject(Router);
  roleService = inject(RoleService);
  toggleService = inject(ToggleService);
  renderer = inject(Renderer2);
  @ViewChild('toggleDiv', { static: false }) toggleDiv!: ElementRef;

  // Listen to the window scroll event
  isDropdownOpen: boolean = false;
  empName: string = 'User';
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollPosition > 100) { // You can adjust the scroll position threshold
      this.isScrolleds = true;
    } else {
      this.isScrolleds = false;
      //this.renderer.addClass(document.body, 'login-bg');
    }
  };

  ngAfterViewInit() {
    const authUser = localStorage.getItem('authUser');
    this.empName = authUser ? JSON.parse(authUser).emp_nm : null;
    this.loaderService.loginStatus.subscribe((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        this.isLoggedIn = true;
      }
      else {
        this.isLoggedIn = false;
      }

    });

  }
  /*
  *   function name: logout()
  *   functionality: to logout user
  *   parameters : none
  */
  public logout() {
    this.authService.logoutcall({}).subscribe((res: any) => {      
      this.route.navigate(['/login']);
      this.loaderService.setLoggedInStatus(false);
      localStorage.clear();
    });
  };

  public forgotPassword() {
    this.route.navigate(['/forget/password']);
    this.loaderService.setLoggedInStatus(false);
  };

  toggleClass() {
    this.toggleService.toggle();
    if (this.toggleDiv) {
      if (this.toggleDiv.nativeElement.classList.contains('open')) {
        this.renderer.removeClass(this.toggleDiv.nativeElement, 'open');
        this.renderer.removeClass(document.body, 'custom-body-fixed'); 
      } else {
        this.renderer.addClass(this.toggleDiv.nativeElement, 'open');
        this.renderer.addClass(document.body, 'custom-body-fixed');
      }
    }
  }

}


